module.exports = __webpack_public_path__ + "static/media/ktm-14.bfea2488.png";